<fgb-banner [pageTitle]="'account.activity.page.title' | translate" />

<fgb-page-header [pageTitle]="'account.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<fgb-account-nav></fgb-account-nav>

<div class="container mt-lg-4">
  <div class="points-history">
    <fgb-transaction-history [transactionTypes]="[transactionTypes.loyalty]" [accountView]="true"></fgb-transaction-history>
  </div>
</div>
